export var CustomFileErrorCode;
(function (CustomFileErrorCode) {
    CustomFileErrorCode["FileNonUniqueName"] = "file-non-unique-name";
    CustomFileErrorCode["NetworkError"] = "network-error";
})(CustomFileErrorCode || (CustomFileErrorCode = {}));
